<template>
  <div class="filters-container" style='min-width: 255px;' :key='forceReloadKey'>
    <q-form class='v-filter-grid' novalidate="novalidate">
      <span>
        <options-filter v-if='testSettings.type == "radio"' :type='testSettings.type' :settings="testSettings" :expanded="testSettings.expand" v-model="valueModel"></options-filter>
        <options-filter v-if='testSettings.type == "checkbox"' :type='testSettings.type' :settings="testSettings" :expanded="testSettings.expand" v-model="arrayModel"></options-filter>
        <dropdown-filter v-if='testSettings.type == "dropdown"' :type='testSettings.type' :settings="testSettings" :expanded="testSettings.expand" v-model="valueModel"></dropdown-filter>
        <slider-filter v-if='testSettings.type == "slider"' :type='testSettings.type' :settings="testSettings" :expanded="testSettings.expand" v-model="objectModel"></slider-filter>
      </span>
    </q-form>
  </div>
</template>

<script setup>
import SliderFilter from './components/filters/SliderFilter.vue'
import OptionsFilter from './components/filters/OptionsFilter.vue'
import DropdownFilter from './components/filters/DropdownFilter.vue'
import { useFilterStore } from "./stores/filter-store";

import { onMounted, onUnmounted, ref, reactive, watch } from 'vue'
import { useSearchStore } from './stores/search-store'

const { getSampleFilterItems } = useFilterStore()
const { debounce } = useSearchStore()

const filterTypes = [null, 'dropdown', 'slider', 'radio', 'checkbox']
const arrayModel = ref([])
const valueModel = ref('')
const objectModel = ref({min: 1, max:100})

const forceReloadKey = ref(1)

let searchableField;
let labelField;
let radioButtons;
let categoryIdField;
let attributeField;
let valueField;
let value2Field;
let sortingField;
let filterColumnField;
let filterValueField;
const filterLabel = ref('');
const filterTypeSelected = ref('')
const expanded = ref(false);
const searchable = ref(false);
const filterItems = ref([
    {value: "1", label:"Lbl 1"},
    {value: "100", label:"Lbl 100"}
  ])
const testSettings = reactive({
  rank: 1,
  type:filterTypeSelected,
  name: filterLabel,
  key:"--",
  expand: expanded,
  searchable: searchable,
  items: filterItems
})

const dataCategory = ref('')
const dataAttribute = ref('')
const dataValue = ref('')
const dataValue2 = ref('')
const dataSorting = ref('')
const dataFilterColumn = ref('')
const dataFilterValue = ref('')
const dataSearch = reactive({
  categoryId: dataCategory,
  label: dataAttribute,
  value: dataValue,
  sortBy: dataValue2,
  sortOrder: dataSorting,
  filterBy: dataFilterColumn,
  filterByValue: dataFilterValue,
})

const eventListeners = [];

const updateKeyValue = () => {
  forceReloadKey.value += 1
};

const updateKeyValueDebounce = debounce(updateKeyValue, 100);

const handleEvent = (event) => {
  if (event.target.id.includes('ExpandOnLoad') && event.target.checked == true) {
    expanded.value = event.target.value.toLowerCase() === 'true';
    updateKeyValueDebounce()
  }
  if (event.target.id.includes('Searchable')) {
    searchable.value = event.target.checked === true;
    updateKeyValueDebounce()
  }
  if (event.target.id.includes('DisplayName')) {
    filterLabel.value = event.target.value;
    updateKeyValueDebounce()
  }
  // if (event.target.id.includes('FilterType')) {
  //   filterTypeSelected.value = document.querySelector('input[name="FilterType"]:checked').value;
  //   updateKeyValueDebounce()
  // }
  if (event.target.id.includes('AdditionalInfo')) {
    dataFilterValue.value = event.target.value;
  }
  if (event.target.id.includes('FilterType') && event.target.checked == true) {
    filterTypeSelected.value = filterTypes[event.target.value];
    // updateKeyValue()
  }
};


async function getFilterData() {
  if (
    !dataSearch?.categoryId || 
    !dataSearch?.label ||
    !dataSearch?.value ||
    !dataSearch?.sortBy
    ) return;
  const results = await getSampleFilterItems(dataSearch)
  const items = results[Object.keys(results)[0]]
  filterItems.value = items.length ? items : filterItems.value
  
  // calling update immediately since we already debounced the api request
  updateKeyValue()
}

const getFilterDataDebounce = debounce(getFilterData, 350);

const handleEventChange = (event) => {
  console.log('event.target.id', event.target.id)
  if (event.target.id == 'CategoryId') dataCategory.value = event.target.value;
  if (event.target.id == 'Attribute') dataAttribute.value = event.target.value;
  if (event.target.id == 'Value') dataValue.value = event.target.value;
  if (event.target.id == 'Value2') dataValue2.value = event.target.value;
  if (event.target.id == 'Sorting') dataSorting.value = event.target.value;
  if (event.target.id == 'FilterOnAttribute') dataFilterColumn.value = event.target.value;
};

const addEventListener = (element, event, handler) => {
  // eslint-disable-next-line
  if (NodeList.prototype.isPrototypeOf(element)) {
    element.forEach((el) => addEventListener(el, event, handler));
    return;
  }
  element.addEventListener(event, handler);
  eventListeners.push({ element, event, handler });
};

onMounted(() => {
  const expandOnLoadYes = document.querySelector('#ExpandOnLoad_Yes')
  const filterType = document.querySelector('input[name="FilterType"]:checked')

  radioButtons = document.querySelectorAll('input[type="radio"]')
  addEventListener(radioButtons, 'click', handleEvent)

  labelField = document.querySelector('#DisplayName')
  addEventListener(labelField, 'input', handleEvent)

  searchableField = document.querySelector('#Searchable')
  addEventListener(searchableField, 'click', handleEvent);

  categoryIdField = document.querySelector('#CategoryId')
  addEventListener(categoryIdField, 'change', handleEventChange)

  attributeField = document.querySelector('#Attribute')
  addEventListener(attributeField, 'change', handleEventChange)

  valueField = document.querySelector('#Value')
  addEventListener(valueField, 'change', handleEventChange)

  value2Field = document.querySelector('#Value2')
  addEventListener(value2Field, 'change', handleEventChange)

  sortingField = document.querySelector('#Sorting')
  addEventListener(sortingField, 'change', handleEventChange)

  filterColumnField = document.querySelector('#FilterOnAttribute')
  addEventListener(filterColumnField, 'change', handleEventChange)
  
  filterValueField = document.querySelector('#AdditionalInfo')
  addEventListener(filterValueField, 'input', handleEvent)
  
  // load initial values to the reactive fields for the filter
  // if we have a filter type selected
  if (filterType?.value) {
    searchable.value = searchableField.checked === true;
    expanded.value = expandOnLoadYes.checked === true;
    console.log('expandOnLoadYes.checked',expandOnLoadYes.checked)
    filterLabel.value = labelField.value;
    filterTypeSelected.value = filterTypes[filterType.value]
    
    // load the initial values for the getFilterData method
    dataCategory.value = categoryIdField.value;
    dataAttribute.value = attributeField.value;
    dataValue.value = valueField.value;
    dataValue2.value = value2Field.value;
    dataSorting.value = sortingField.value;
    dataFilterColumn.value = filterColumnField.value;
    dataFilterValue.value = filterValueField.value;
    
    // refresh the filter data/component to reflect the initial values
    updateKeyValueDebounce()
  } else {
    dataSorting.value = sortingField.value;
  }
})

watch(dataSearch, () => {
  console.log('dataSearch requested')
  if (document.querySelector('input[name="FilterType"]:checked')) getFilterDataDebounce()
})

onUnmounted(() => {
  eventListeners.forEach(({ element, event, handler }) => {
    element.removeEventListener(event, handler);
  });
})
</script>
